import {Component, EventEmitter, OnDestroy, Output, ViewChild} from '@angular/core';
import {BinaryData} from '../../../../../model/proposal/binary-data';
import {FormBuilder, FormControl} from '@angular/forms';
import {OfferFormBase} from '../offer-form-base/offer-form-base.component';
import {Offer} from '../../../../../model/offer/offer';
import {Observable, of} from 'rxjs';
import {UploadComponent} from '../../../../upload-field/upload.component';
import {UploadLocation} from '../../../../../enum/upload-location';

@Component({
    selector: 'app-offer-file-upload',
    templateUrl: './offer-file-upload.component.html',
    providers: [{ provide: OfferFormBase, useExisting: OfferFileUploadComponent }],
    standalone: false
})
export class OfferFileUploadComponent extends OfferFormBase implements OnDestroy {

  @ViewChild(UploadComponent) uploadComponent: UploadComponent;

  @Output() uploadInProgress = new EventEmitter<boolean>();
  constructor(private readonly fb: FormBuilder) {
    super();
  }

  formGroup = this.fb.group({
    attachedFiles: new FormControl([])
  });

  updateOffer(offer: Offer): void {
    offer.attachedFiles = this.formGroup.value.attachedFiles;
  }

  attachFiles(attachedFiles: BinaryData[]): void {
    this.formGroup.setValue({
      attachedFiles: attachedFiles
    });
  }

  override validStatus(): Observable<boolean> {
    return of(true);
  }

  sendUploadStatus(data: boolean) {
    this.uploadInProgress.emit(data);
  }

  prefill(offer: Offer): void {
    this.formGroup.patchValue({
      attachedFiles: offer.attachedFiles || []
    });
    this.uploadComponent.addPreUploadedFiles(offer.attachedFiles || []);
  }

  ngOnDestroy() {
    this.formGroup.reset();
    this.uploadComponent.clear();
  }

  reset() {
    this.formGroup.reset();
    this.uploadComponent.clear();
  }

  protected readonly UploadLocation = UploadLocation;
}
